var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconDualtoneSportsclubs48 = function SvgAIconDualtoneSportsclubs48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 8C15.5066 8 7 16.5066 7 27C7 37.4934 15.5066 46 26 46C36.4934 46 45 37.4934 45 27C45 21.9609 42.9982 17.1282 39.435 13.565C35.8718 10.0018 31.0391 8 26 8Z",
    fill: "#F9CCD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2C9.50659 2 1 10.5066 1 21C1 31.4934 9.50659 40 20 40C30.4934 40 39 31.4934 39 21C39 15.9609 36.9982 11.1282 33.435 7.56497C29.8718 4.00178 25.0391 2 20 2Z",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7541 29.0288L11.5283 19.0644L19.9981 12.9067L28.4679 19.0644L25.2421 29.0288H14.7541V29.0288Z",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2671 3.43719L20.0032 8.33328L12.7393 3.43719",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3916 39.4899L28.0041 32.1162L36.2527 30.8495",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9431 22.5351L33.1553 16.7709L34.3966 8.59839",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.33319V12.9067",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4717 19.0643L33.1533 16.7708",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.05762 22.5351L6.84544 16.7709L5.60411 8.59839",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5263 19.0643L6.84473 16.7708",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.249 29.0289L28.007 32.1162",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6111 39.4899L11.9985 32.1162L3.75 30.8495",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7589 29.0289L12.001 32.1162",
    stroke: "#E2001A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconDualtoneSportsclubs48 as ReactComponent };
export default "data:image/svg+xml;base64,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";